export default function ChevronIcon() {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.19924 10.4746L1.64941 5.92482L6.19924 1.375"
        stroke="currentColor"
        strokeWidth="1.81993"
      />
    </svg>
  );
}
